export default __webpack_public_path__ + "static/media/star-red.6430150c.svg";